var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},[_c('home-common-search'),_c('goodsclass-body')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }